import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CardValueWithLeftColor from '../../../components/common/CardValueWithLeftColor';

const CardQuantoGasteiDesejos = (props) => {
	const {
		lancamentos,
		loading,
		title = 'Meus gastos não essenciais'
	} = props;

	const [totalDesejos, setTotalDesejos] = useState(0);

	useEffect(() => {
		setTotalDesejos(
			lancamentos &&
				lancamentos.length > 0
				? lancamentos
						.filter((item) => item.tipoLancamento.value === 'desejo')
						.reduce((sum, record) => sum + record.valor, 0)
				: 0
		);

		// eslint-disable-next-line
	}, [lancamentos]);

	return (
		!loading && (
			<CardValueWithLeftColor
				title={title}
				leftColor='border-left-secondary'
				countup={false}
				icon='fas fa-glass-cheers'
				// icon='fas fa-arrow-up'
				value={totalDesejos}
			/>
		)
	);
};

CardQuantoGasteiDesejos.propTypes = {
	title: PropTypes.string
};

const mapStateToProps = (state) => ({
	lancamentos: state.arrumaCasaStore.lancamentos,
	loading: state.commonStore.loading,
});

export default connect(mapStateToProps)(
	CardQuantoGasteiDesejos
);
